
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.519.037C5.167.037 0 5.204 0 11.555c0 6.352 5.167 11.519 11.519 11.519 6.35 0 11.518-5.167 11.518-11.519C23.037 5.204 17.87.037 11.52.037","fill":"#000"}}),_c('path',{attrs:{"d":"M11.182 6.34l.06.002c.782 0 1.42-.613 1.453-1.397.032-.816-.601-1.48-1.442-1.514h-.011c-.783 0-1.422.613-1.454 1.396-.033.8.592 1.48 1.394 1.514m1.434 11.891V7.959H9.122v1.448h1.43v8.825h-1.3v1.448h4.665v-1.448z","fill":"#FFF"}})])])
          )
        }
      }
    